import { Button } from "@/components/ui/button";

interface TradeButtonsProps {
  onTrade: (isBuy: boolean) => void;
}

const TradeButtons = ({ onTrade }: TradeButtonsProps) => {
  return (
    <div className="flex justify-between mb-4">
      <Button 
        variant="default" 
        className="w-1/2 bg-green-500 hover:bg-green-600"
        onClick={() => onTrade(true)}
      >
        buy
      </Button>
      <Button 
        variant="secondary" 
        className="w-1/2 ml-2"
        onClick={() => onTrade(false)}
      >
        sell
      </Button>
    </div>
  );
};

export default TradeButtons;